export const LOCATIONS_ACTION_TYPES = {
  LOAD_COUNTRIES: 'locations/LOAD_COUNTRIES',
  SUCCESS_COUNTRIES: 'locations/SUCCESS_COUNTRIES',
  CHANGE_COUNTRIES_SEQUENCE: 'locations/CHANGE_COUNTRIES_SEQUENCE',
  LOAD_CITIES: 'locations/LOAD_CITIES',
  SUCCESS_CITIES: 'locations/SUCCESS_CITIES',
  CHANGE_CITIES_SEQUENCE: 'locations/CHANGE_CITIES_SEQUENCE',
  LOAD_BULK: 'locations/LOAD_BULK',
  RESET_CITIES: 'locations/RESET_CITIES',
};

export const requestCountriesList = {
  type: LOCATIONS_ACTION_TYPES.LOAD_COUNTRIES,
};

export const successCountriesList = (data) => {
  return {
    type: LOCATIONS_ACTION_TYPES.SUCCESS_COUNTRIES,
    payload: data,
  };
};

export const requestChangeCountrySequence = (data) => {
  return {
    type: LOCATIONS_ACTION_TYPES.CHANGE_COUNTRIES_SEQUENCE,
    payload: data,
  };
};

export const requestCitiesList = (country) => {
  return {
    type: LOCATIONS_ACTION_TYPES.LOAD_CITIES,
    payload: country,
  };
};

export const successCitiesList = (data) => {
  return {
    type: LOCATIONS_ACTION_TYPES.SUCCESS_CITIES,
    payload: data,
  };
};

export const requestChangeCitiesSequence = (data) => {
  return {
    type: LOCATIONS_ACTION_TYPES.CHANGE_CITIES_SEQUENCE,
    payload: data,
  };
};



